// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"175":"b6fc5825","320":"2a143527"}[chunkId] + ".chunk.css";
};